<template>
  <div class="page withdraw-protocol">
    <navigation customClickEvent @click="back">相关协议</navigation>

    <nd-cell class="navigate-item"
             v-for="(item, index) in protocolList"
             :key="index"
             :title="item.title"
             @click="clickProtocol(item)"
    >
    </nd-cell>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey } from '../../assets/utils'
export default {
  name: 'withdraw-protocol',

  customReadyNotify: true,

  description: '提现相关协议',

  data () {
    return {
      protocolList: []
    }
  },

  async created () {
    try {
      await this.getProtocolList()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  methods: {
    ...mapActions('order', ['getOrderAgreementX']),

    async getProtocolList () {
      const response = await this.getOrderAgreementX({
        busiType: this.$route.query.busiType || 'LOAN',
        fundCode: this.$route.query.fundCode,
        // 大权益需要添加的参数
        hasGreatVip: this.$route.query.loanProcess === 'GVIP'
      })
      if (response.success) {
        this.protocolList = response.data
      }
    },

    clickProtocol (item) {
      const gid = getKey('gid')
      const { mobile, userId } = getKey('userInfo') || {}
      window.location.href = `${item.path}?gid=${gid}&userId=${userId}&phoneNumber=${mobile}`
      // window.location.href = item.path
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.withdraw-protocol {
    background-color: #fafafa;

      .navigate-item {
          height: 110px;
          line-height: 1.5;
          margin-top: 0px;
          padding-left: 15px;
          padding-right: 17px;
          border-bottom: 1px solid @iuc;
      }
}
</style>

